import useUser from 'src/hooks/use-user';
import { useEffect } from 'react';
import { tracker } from '..';

export const useUserMonitor = (): void => {
  const { user } = useUser();

  useEffect(() => {
    // FIXME: we see instances that the user.id is null, do we want to exclude these tracker calls?
    tracker.setContext({ activeUser: user });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.id /* only update when the userId changes */]);
};
